import React from 'react';
import styled from 'styled-components';
import { Box } from 'rebass';

import Icon from '../Icon/Icon';
import Link from '../../base/Link/Link';

const SocialLink = styled(Link)`
  margin-left: ${(props) => (props.$withBackground ? 0 : '-12px')};
  margin-right: 10px;
`;

// TODO(Peter): Move ordering to meta component
const socials = [
  {
    icon: 'linkedin',
    makeHref: (url) =>
      `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
  },
  {
    icon: 'twitter',
    makeHref: (url) => `https://twitter.com/intent/tweet?url=${url}`,
  },
  {
    icon: 'mail',
    makeHref: (url) => `mailto:?body=${url}`,
  },
  {
    icon: 'whatsapp',
    makeHref: (url) => `https://wa.me/?text=${url}`,
  },
  {
    icon: 'facebook',
    makeHref: (url) =>
      `https://www.facebook.com/sharer.php?display=page&u=${url}`,
  },
];

/**
 * Renders a collection of social links with sharing capabilities
 * Gets rendered without url to prevent layout shift
 * @param {Object} props
 * @param {string} props.colourScheme
 * @param {number} [props.size] - Size of icons in px
 * @param {string} [props.url] - Url to share (Defaults to window.location.href)
 * @param {boolean} [props.withBackground] - Whether to show background
 */
const SocialShare = ({
  colourScheme,
  size = 25,
  url = typeof window !== 'undefined' && window.location.href,
  withBackground,
}) => {
  const encodedUrl = encodeURIComponent(url || '');

  return (
    <Box ml={withBackground ? 0 : 1}>
      {socials.map(({ icon, makeHref }) => (
        <SocialLink
          key={icon}
          href={makeHref(encodedUrl)}
          $withBackground={withBackground}
        >
          <Icon
            colourScheme={colourScheme}
            height={size}
            icon={icon}
            width={size}
            withBackground={withBackground}
          />
        </SocialLink>
      ))}
    </Box>
  );
};

export default SocialShare;
